import React from "react";

const LabelHeading = ({ className, label }) => {
  return (
    <p className={`font-bold ${className} px-[15px] mb-[15px]`}>{label}</p>
  );
};

export default LabelHeading;
